import { makeBusinessEntity, PartialBusinessEntityOptions } from "../../../lib/libby/generator";
import { Confirmation } from "../../models";
import { businessOptions } from "../businessOptions";

const DAO_NAME = "confirmation";

const defaultOptions: PartialBusinessEntityOptions<any> = {
  hoc: {
    withAccordionSelector: {
      idKey: "confirmation_id",
      labelKey: "email",
    },
    withSelectedChips: {
      idKey: "confirmation_id",
      labelKey: "email",
    },
  },
};

const optionsToUse = !businessOptions.Confirmation
  ? defaultOptions
  : {
      ...defaultOptions,
      ...businessOptions.Confirmation,
      hoc: { ...defaultOptions.hoc, ...businessOptions.Confirmation.hoc },
    };

const {
  hook: { fetchById, libbyCall, libbyDAO, libbyFetch },
  hoc: { entityAutocomplete, renderPropCall, renderPropFetchById, simpleSelect, accordionSelector, selectedChips },
  context: {
    byIdContext: { useByIdContext, ByIdProvider, ByIdContext },
  },
} = makeBusinessEntity<Confirmation>(DAO_NAME, optionsToUse);

// hooks
export const useConfirmationFetchById = fetchById;
export const useConfirmationLibbyCall = libbyCall;
export const useConfirmationDAO = libbyDAO;
export const useConfirmationLibbyFetch = libbyFetch;

// components/hoc
export const ConfirmationAutocomplete = entityAutocomplete;
export const ConfirmationCall = renderPropCall;
export const ConfirmationById = renderPropFetchById;
export const ConfirmationSelect = simpleSelect;
export const ConfirmationAccordionSelector = accordionSelector;
export const ConfirmationSelectedChips = selectedChips;

// context
// ByIdContext
export const useConfirmationByIdContext = useByIdContext;
export const ConfirmationByIdProvider = ByIdProvider;
export const ConfirmationByIdContext = ByIdContext;
// GeneralContext
// export const useConfirmationContext = useGeneralContext;
// export const ConfirmationProvider = GeneralProvider;
// export const ConfirmationContext = GeneralContext; // Para esta entidad usaremos un contexto personalizado
